import Icon from 'components/Icon';
import { Col, Form, Spinner } from "react-bootstrap";
import { IFormInputDefault } from './interfaces';
interface IBase{
  props:IFormInputDefault;
  twoColumn?: boolean;
  children:any;
}

export default function BodyInputFormat({props, children, twoColumn}:IBase){
  const title = props.title;
  const required = props.required;
  const disabled = props.disabled;
  const cleanable = props.cleanable;
  const load = props.load
  const onClear = props.onClear;
  return (
    <Col md={props.md} xs={props.xs} className="newform-col">
      <Form.Group>
        {title?<Form.Label>{title}{(required && !disabled)?(<label style={{color: 'red'}}>*</label>):""}</Form.Label>:""}
        <div className={"area-input"+(twoColumn?" two-column":"")}>
          {children}
          {cleanable && 
            <div className="clear-icon" onClick={(e)=>{
              try {
                let target:any = e.target;
                if(target && target.parentElement){
                  target = target.parentElement;
                  if(target && target.parentElement){
                    let inputs = target.parentElement.getElementsByTagName("input");
                    if(inputs.length>0){
                      e.target = inputs[0];
                      if(onClear)onClear({...e, target: inputs[0]});
                    }
                  }
                }
              } catch (error) {
                console.log(error); 
              }
              
            }}>
              <Icon name="times-circle"/>
            </div>
          }

          {load && 
            <div className="clear-icon">
              <Spinner size="sm" animation="border" />
            </div>
          }
        </div>
      </Form.Group>
    </Col>
  );
}